import React from "react";
import * as S from "./styles";
export var ErrorMessage = function ErrorMessage(_ref) {
  var errors = _ref.errors;
  return errors && errors.length ? React.createElement(S.ErrorMessage, null, React.createElement(S.ErrorParagraph, null, errors[0].message)) : null;
};